module.exports = __webpack_public_path__ + "posture/static/img/badge.3c72576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badge.png
// module id = flp1
// module chunks = 1